import React from "react";
import { SPORTSLINK_LOGO, SPORTSLINK_TAGLINE } from "@/lib/brand";

/**
 * Compact "Powered by SportsLink" credit badge for use in
 * login/register pages and admin sidebar.
 */
export default function PoweredBy({ className = "" }) {
  return (
    <a
      href="#"
      data-testid="powered-by-sportslink"
      className={`inline-flex items-center gap-2.5 group ${className}`}
      title={`Built by SportsLink — ${SPORTSLINK_TAGLINE}`}
    >
      <span className="text-[9px] uppercase tracking-[0.3em] text-[#64748B] group-hover:text-[#94A3B8] transition font-semibold">
        Powered by
      </span>
      <img
        src={SPORTSLINK_LOGO}
        alt="SportsLink"
        className="h-7 w-7 rounded-full ring-1 ring-white/10 group-hover:ring-[#00F0FF]/50 transition"
      />
      <span className="font-display font-black text-xs tracking-tight">
        <span className="text-white/85">sports</span>
        <span className="text-[#00F0FF]">link</span>
      </span>
    </a>
  );
}
